export var CREATE_METHOD_REQUEST = 'src/MethodNew/CREATE_METHOD_REQUEST';
export var CREATE_METHOD_SUCCESS = 'src/MethodNew/CREATE_METHOD_SUCCESS';
export var CREATE_METHOD_FAILURE = 'src/MethodNew/CREATE_METHOD_FAILURE';
export var GET_METHOD_REQUEST = 'src/MethodEdit/GET_METHOD_REQUEST';
export var GET_METHOD_SUCCESS = 'src/MethodEdit/GET_METHOD_SUCCESS';
export var GET_METHOD_FAILURE = 'src/MethodEdit/GET_METHOD_FAILURE';
export var UPDATE_METHOD_REQUEST = 'src/MethodEdit/UPDATE_METHOD_REQUEST';
export var UPDATE_METHOD_SUCCESS = 'src/MethodEdit/UPDATE_METHOD_SUCCESS';
export var UPDATE_METHOD_FAILURE = 'src/MethodEdit/UPDATE_METHOD_FAILURE';
export var DELETE_METHOD_REQUEST = 'src/MethodEdit/DELETE_METHOD_REQUEST';
export var DELETE_METHOD_SUCCESS = 'src/MethodEdit/DELETE_METHOD_SUCCESS';
export var DELETE_METHOD_FAILURE = 'src/MethodEdit/DELETE_METHOD_FAILURE';
export var LOAD_INTEGRATION_REQUEST = 'src/MethodEdit/LOAD_INTEGRATION_REQUEST';
export var LOAD_INTEGRATION_SUCCESS = 'src/MethodEdit/LOAD_INTEGRATION_SUCCESS';
export var LOAD_INTEGRATION_FAILURE = 'src/MethodEdit/LOAD_INTEGRATION_FAILURE';
export var RUN_METHOD_REQUEST = 'src/MethodEdit/RUN_METHOD_REQUEST';
export var RUN_METHOD_SUCCESS = 'src/MethodEdit/RUN_METHOD_SUCCESS';
export var RUN_METHOD_FAILURE = 'src/MethodEdit/RUN_METHOD_FAILURE';
